import React from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useNavigate } from "react-router-dom"; // Assuming you're using React Router
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

function ErrorPage() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    window.scrollTo(0, 0);
    navigate("/"); 
  };

  return (
    <>
      <Header />
      <Container
        maxWidth="md"
        sx={{
          textAlign: "center",
          mt: 8,
          mb: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "85vh",
        }}
      >
        <Box sx={{ mb: 4 }}>
          <ErrorOutlineIcon color="error" sx={{ fontSize: 80 }} />
        </Box>
        <Typography variant="h2" component="h1" gutterBottom>
          Oops! Page Not Found
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          The page you are looking for might have been removed or is temporarily
          unavailable.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleGoHome}
          sx={{ padding: "10px 30px" }}
        >
          Go to Homepage
        </Button>
      </Container>
      <Footer />
    </>
  );
}

export default ErrorPage;
